import { render, staticRenderFns } from "./TaskListItem.vue?vue&type=template&id=39f6ca1e&"
import script from "./TaskListItem.vue?vue&type=script&lang=ts&"
export * from "./TaskListItem.vue?vue&type=script&lang=ts&"
import style0 from "./TaskListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports